import React from 'react'
import '../../../../../../styles/modalStyle.css'
import BirthModalComponent from "./BirthModalComponent";



export default function UpdateBirthModal(props){

    const {open, close, header, sectionType } = props;

    return(
        <>
            <div className={open ? 'openModal modal' : 'modal'}>
                {open ? (
                    <>
                        {sectionType === 'mobile' ? (
                            <>
                                <sectionMobile style={{marginTop:50}}>
                                    <header>
                                        {header}
                                        <button className="close" onClick={close}>
                                            &times;
                                        </button>
                                    </header>
                                    <main style={{alignItems: "center"}}><BirthModalComponent style={{alignItems: "center"}}
                                                                                              sectionType="mobile" />
                                    </main>
                                    <footer>
                                        <button className="close" onClick={close}>
                                            닫기
                                        </button>
                                    </footer>
                                </sectionMobile>
                            </>
                        ):(
                            <>
                                <section style={{marginTop:50}}>
                                    <header>
                                        {header}
                                        <button className="close" onClick={close}>
                                            &times;
                                        </button>
                                    </header>
                                    <main style={{alignItems: "center"}}><BirthModalComponent style={{alignItems: "center"}} /></main>
                                    <footer>
                                        <button className="close" onClick={close}>
                                            닫기
                                        </button>
                                    </footer>
                                </section>
                            </>
                        )}


                    </>
                ) : null}
            </div>
        </>
    )
}